import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function PrivacyPage() {
  const navigate = useNavigate();

  return (
    <div data-testid="privacy-page" className="min-h-screen bg-background page-with-nav">
      <div className="sticky top-0 z-30 bg-background/95 backdrop-blur-sm border-b-2 border-border px-4 py-3 flex items-center gap-3">
        <button data-testid="privacy-back-btn" onClick={() => navigate(-1)} className="min-w-[44px] min-h-[44px] flex items-center justify-center">
          <ArrowLeft className="w-6 h-6 text-foreground" />
        </button>
        <span className="font-heading text-lg text-primary uppercase">Privacidad</span>
      </div>

      <div className="max-w-2xl mx-auto px-5 py-8 space-y-8">
        <div>
          <h1 className="font-heading text-3xl text-primary uppercase leading-tight">Aviso de Privacidad</h1>
          <div className="border-t-4 border-primary w-16 mt-3" />
        </div>

        <p className="text-foreground/80 font-body text-sm leading-relaxed">
          En cumplimiento con la <strong className="text-foreground">Ley Federal de Proteccion de Datos Personales en Posesion de los Particulares (LFPDPPP)</strong> de Mexico, ponemos a tu disposicion el presente Aviso de Privacidad.
        </p>

        {/* Seccion 1 */}
        <section className="space-y-3">
          <h2 className="font-heading text-xl text-foreground uppercase">1. Datos que Recabamos</h2>
          <p className="text-muted-foreground font-body text-sm leading-relaxed">
            Al utilizar Bisne, recopilamos los siguientes datos personales:
          </p>
          <ul className="text-muted-foreground font-body text-sm leading-relaxed space-y-2 pl-4">
            <li className="flex gap-2"><span className="text-primary font-bold shrink-0">-</span><strong className="text-foreground">Datos de cuenta:</strong> Correo electronico, nombre completo y foto de perfil (a traves de Google).</li>
            <li className="flex gap-2"><span className="text-primary font-bold shrink-0">-</span><strong className="text-foreground">Ubicacion:</strong> La localidad que selecciones al publicar articulos.</li>
            <li className="flex gap-2"><span className="text-primary font-bold shrink-0">-</span><strong className="text-foreground">Datos de verificacion (KYC):</strong> Imagenes de tu identificacion oficial (INE) y CURP, utilizados para validar tu identidad.</li>
            <li className="flex gap-2"><span className="text-primary font-bold shrink-0">-</span><strong className="text-foreground">Datos de pago:</strong> CLABE interbancaria, numero de cuenta y nombre del banco (proporcionados voluntariamente).</li>
          </ul>
        </section>

        {/* Seccion 2 */}
        <section className="space-y-3">
          <h2 className="font-heading text-xl text-foreground uppercase">2. Uso de los Datos</h2>
          <p className="text-muted-foreground font-body text-sm leading-relaxed">
            Tus datos personales son utilizados para los siguientes fines:
          </p>
          <ul className="text-muted-foreground font-body text-sm leading-relaxed space-y-2 pl-4">
            <li className="flex gap-2"><span className="text-primary font-bold shrink-0">-</span>Crear y mantener tu cuenta en la plataforma.</li>
            <li className="flex gap-2"><span className="text-primary font-bold shrink-0">-</span>Facilitar la comunicacion entre compradores y vendedores.</li>
            <li className="flex gap-2"><span className="text-primary font-bold shrink-0">-</span>Validar tu identidad, prevenir fraudes y mantener una comunidad segura.</li>
          </ul>
          <div className="border-2 border-primary/40 bg-primary/5 p-4 rounded-sm">
            <p className="text-foreground font-body text-sm leading-relaxed font-semibold">
              Tus documentos oficiales son almacenados en servidores seguros y utilizados UNICAMENTE para validar tu identidad. NUNCA venderemos tus documentos ni datos personales a terceros.
            </p>
          </div>
        </section>

        {/* Seccion 3 */}
        <section className="space-y-3">
          <h2 className="font-heading text-xl text-foreground uppercase">3. Derechos ARCO</h2>
          <p className="text-muted-foreground font-body text-sm leading-relaxed">
            Conforme a la LFPDPPP, tienes derecho a <strong className="text-foreground">Acceder, Rectificar, Cancelar u Oponerte</strong> al tratamiento de tus datos personales (derechos ARCO).
          </p>
          <ul className="text-muted-foreground font-body text-sm leading-relaxed space-y-2 pl-4">
            <li className="flex gap-2"><span className="text-primary font-bold shrink-0">-</span>Puedes solicitar la eliminacion de tu cuenta y todos tus datos en cualquier momento.</li>
            <li className="flex gap-2"><span className="text-primary font-bold shrink-0">-</span>Para ejercer tus derechos ARCO, envianos un correo electronico o elimina tu cuenta directamente desde la aplicacion.</li>
          </ul>
        </section>

        {/* Seccion 4 */}
        <section className="space-y-3">
          <h2 className="font-heading text-xl text-foreground uppercase">4. Seguridad</h2>
          <p className="text-muted-foreground font-body text-sm leading-relaxed">
            Implementamos medidas de seguridad tecnicas y administrativas para proteger tus datos contra acceso no autorizado, perdida o alteracion. Sin embargo, ninguna transmision de datos por internet es 100% segura.
          </p>
        </section>

        {/* Seccion 5 */}
        <section className="space-y-3">
          <h2 className="font-heading text-xl text-foreground uppercase">5. Modificaciones</h2>
          <p className="text-muted-foreground font-body text-sm leading-relaxed">
            Nos reservamos el derecho de actualizar este Aviso de Privacidad. Cualquier cambio sera publicado en esta misma pagina.
          </p>
        </section>

        <div className="border-t border-border pt-4">
          <p className="text-muted-foreground/50 font-body text-xs text-center">Ultima actualizacion: Febrero 2026</p>
        </div>
      </div>
    </div>
  );
}
